angular.module('unica_media_upload.media_services')

.factory('MediaUploadDeleteService', function ($http, getBaseApiURL) {

	var mediaDeleteService = {};

	mediaDeleteService.delete = function (mediaId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/media-upload/delete/' + mediaId,
			data: {	}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return mediaDeleteService;
});